export default __webpack_public_path__ + "static/media/su.a2d9eec8.jpg";